const words = ['YOGA', 'MEDITAÇÃO', 'EQUILÍBRIO', 'BEM-ESTAR', 'RESPIRAÇÃO', 'FORÇA', 'HARMONIA'];
const text = words.join(' • ') + ' • ';
const repeated = text + text;

export default function MarqueeSection() {
  return (
    <div className="py-5 border-y border-beige/60 overflow-hidden bg-cream">
      <div
        className="whitespace-nowrap animate-marquee inline-block"
        style={{ willChange: 'transform' }}
      >
        <span className="font-dm text-xs tracking-[0.35em] text-sage/60 uppercase">
          {repeated}
        </span>
        <span className="font-dm text-xs tracking-[0.35em] text-sage/60 uppercase">
          {repeated}
        </span>
      </div>
    </div>
  );
}
